import {
  AddMembersToPermissionGroupDocument,
  AddMembersToPermissionGroupMutationVariables,
  PermissionsPermissionsDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export default function useAddMembersToPermissionGroup() {
  const [mutation, { loading }] = useMutation(AddMembersToPermissionGroupDocument, {
    extractorFn: (data) => data.permissionsMutations.addMembersPermissionsPermissionGroup,
  })

  const addMembersToPermissionGroup = useUnsafeCallback(
    async (variables: AddMembersToPermissionGroupMutationVariables) => {
      const result = await mutation({
        variables,
        refetchQueries: [PermissionsPermissionsDocument],
      })
      handleResult(result, () => {})
    },
    [mutation]
  )

  return [addMembersToPermissionGroup, loading] as const
}
